import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { GET_COMPANY_INTEGRATION, SET_COMPANY_INTEGRATION } from "../../services/companies";
import InputField, { InputFieldTypes } from "../input_field";
import { Avatar, Box, Button, Group, Stack, Text, Title } from "@mantine/core";

export default function OpenAi() {
    const [data, setData] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [updated, setUpdated] = useState<boolean>(false);

    const handleChange = dt => setData(u => ({ ...u, ...dt }))

    const loadData = () => {
        GET_COMPANY_INTEGRATION("open_ai")
            .then((res) => {
                setData(res)
                setTimeout(() => { setUpdated(false) }, 800);
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    const handleSave = () => {
        setLoadingSave(true)
        SET_COMPANY_INTEGRATION("open_ai", { ...data })
            .then((res) => {
                setLoadingSave(false)
                setUpdated(false);
                notifications.show({ message: "Connected on OPEN AI", color: 'green' })
            })
            .catch(err => {
                setLoadingSave(false)
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    React.useEffect(() => { loadData() }, [])
    React.useEffect(() => { setUpdated(true) }, [data])

    return <Stack>
        <Group>
            <Avatar size={40} src="/assets/open_ai.png" />
            <Title c="gray.0" order={5}>Open AI</Title>
        </Group>
        <Group align="flex-end">
            <Box style={{ flex: 1 }}>
                <InputField
                    name="key"
                    value={data?.key}
                    fieldType={InputFieldTypes.PASSWORD}
                    onChange={handleChange}
                    title="Project API Key"
                    placeholder="Paste your project API KEY"
                />
            </Box>
            {/* <InputField
                name="secret"
                value={data?.secret}
                fieldType={InputFieldTypes.PASSWORD}
                onChange={handleChange}
                title="SECRET KEY"
            /> */}

            {/* <Button
                    size="xs"
                    onClick={() => {
                        SET_COMPANY_INTEGRATION("open_ai", { key: "", secret: "" })
                        .then(() => {
                            setData(d => ({ ...d, key: "", secret: "" }))
                            notifications.show({message: "Disconnected", color: 'green'})
                        })
                        .catch(err => { notifications.show({title: "Ops.", message: err.message, color: 'red'}) })
                    }}
                    color="red"
                    variant="transparent"
                    className="draw-button"
                >Disconnect</Button> */}
            <Button
                disabled={
                    ((data?.key ?? "").length < 10) || !data.key.startsWith("sk-proj-") || !updated
                }
                size="md"
                onClick={handleSave}
                loading={loadingSave}
                color="green"
            >Connect</Button>
        </Group>
        {(data?.key?.length > 10 && !data.key.startsWith("sk-proj-")) &&
            <Text c="red" size="xs">You need to insert a project key</Text>}
    </Stack>
}
